import { Login as DefaultLogin } from '@frx/frx-program-defaults';

export const Login = () => <DefaultLogin />;
